import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { Text } from "#components/atoms/Typographies/Text";
import { Modal } from "#components/molecules/Modal/Modal";

type Props = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ChangePartFormatConfirmationModal = ({ opened, onClose, onConfirm }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("quoteRequestV2.changeFormatModal.title")}
      closeText={t("quoteRequestV2.changeFormatModal.cancel")}
      primaryText={t("quoteRequestV2.changeFormatModal.confirm")}
      onPrimary={onConfirm}
    >
      <Text size="small" color={colors.text.secondaryDefault}>
        {t("quoteRequestV2.changeFormatModal.body")}
      </Text>
    </Modal>
  );
};
